const rankingItems = [
  { rank: 1, title: '哪吒之魔童闹海', category: '动画电影', heat: '9.8', change: 'up', icon: 'ri-medal-line' },
  { rank: 2, title: '庆余年 第三季', category: '古装剧集', heat: '9.6', change: 'up', icon: 'ri-medal-line' },
  { rank: 3, title: '流浪地球3', category: '科幻电影', heat: '9.5', change: 'up', icon: 'ri-medal-line' },
  { rank: 4, title: '鬼灭之刃 无限城篇', category: '热血动漫', heat: '9.4', change: 'new', icon: 'ri-flashlight-line' },
  { rank: 5, title: '乘风破浪的姐姐', category: '综艺节目', heat: '9.3', change: 'up', icon: 'ri-medal-line' },
  { rank: 6, title: '奥本海默', category: '传记电影', heat: '9.2', change: 'down', icon: 'ri-medal-line' },
];

const medalColors = ['text-primary-400', 'text-secondary-400', 'text-accent-400'];

export default function Ranking() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热度榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            8090观众评分最高的热门影视，每周实时更新
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 px-5 md:px-6 py-4 hover:bg-background-200/30 transition-colors duration-200 cursor-pointer ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/40' : ''
              }`}
            >
              <div className={`w-8 h-8 flex items-center justify-center font-heading text-lg font-black ${
                idx < 3 ? medalColors[idx] : 'text-foreground-400'
              }`}>
                {item.rank <= 3 ? (
                  <i className={`${item.icon} text-xl`}></i>
                ) : (
                  <span className="text-sm">{item.rank}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 truncate">{item.title}</h3>
                <span className="text-xs text-foreground-500">{item.category}</span>
              </div>

              <div className="flex items-center gap-2">
                <span className="text-sm font-bold text-primary-500 whitespace-nowrap">{item.heat}</span>
                <span className={`text-xs whitespace-nowrap ${
                  item.change === 'up' ? 'text-accent-400' : item.change === 'new' ? 'text-primary-500' : 'text-foreground-400'
                }`}>
                  {item.change === 'up' && <i className="ri-arrow-up-line"></i>}
                  {item.change === 'down' && <i className="ri-arrow-down-line"></i>}
                  {item.change === 'new' && 'NEW'}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}